import { toastManager } from '@systemeio/components'
import { useTranslation } from 'next-i18next'
import useSWR from 'swr'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import type { HTMLString } from 'shared/types/html-string'
import { MEMBERSHIP_API } from 'modules/school/api/membership-api'
import type { CourseLecturePreviewHash } from '../types/course-lecture-interface'

export interface UseCourseProps {
  hash: CourseLecturePreviewHash | undefined
  shouldRender?: boolean
}

interface UseCourseLecturePreviewResult {
  courseLecturePreview: string | undefined
}

export function useCourseLecturePreview({
  hash,
  shouldRender = true,
}: UseCourseProps): UseCourseLecturePreviewResult {
  const { t } = useTranslation()
  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.get, HTMLString>({
    method: RequestMethodsEnum.get,
  })

  const { data: courseLecturePreview } = useSWR<HTMLString>(
    () => hash !== undefined && shouldRender && `${MEMBERSHIP_API}/lecture/preview/${hash}`,
    fetcher,
    { onError: () => toastManager.add({ type: 'error', title: t('global.error') }) },
  )

  return { courseLecturePreview }
}
